import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../../../shared/services/api.service';
import { AppInfo, RESPONSE, EitUrl, EitEnv } from '../../../shared/services/env.service';
import { ProfileTabs, StatusOrder, StatusRide, TypeOrder } from '../../../shared/services/config-app';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from '../../../shared/components/modal/confirm/confirm.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CancelbookingComponent } from '../../../shared/components/modal/cancelbooking/cancelbooking.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @ViewChild("confirmModal") ConfirmModal: ConfirmComponent;
  openDashboard: boolean = false;
  tab: number = 0;
  accountForm: FormGroup;
  pwdForm: FormGroup;
  fidelity : any = {};
  join : any = {};
  reviews : Array<any> = [];
  orders : Array<any> = [];
  bookings : Array<any> = [];
  messages : Array<any> = [];
  partners : Array<any> = [];
  queryPageO: number = 0;
  queryPageB: number = 0;
  profileTabs: any = ProfileTabs;
  rideStatus: any = StatusRide;
  appData: any = null;
  fidelity_type: number = 0;
  c_index: number = 0;
  n: number = 0;
  max: number = 1000;
  couponAvailable: boolean = false;
  title: string = ""
  appInfo: any = AppInfo
  collapseOrder: Array<any> = [];
  public typeOrder: any = TypeOrder;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private modalService: NgbModal, private api: ApiService, 
              private toastService: ToastrService, private authService: AuthService, private appService: AppService) {
    if(!authService.currentUserValue){
      //this.router.navigate(['/login'], {queryParams: {returnUrl:"/account"}});
      this.route.queryParams.subscribe(params => {
        console.log(params); 
        if (params && params.token){
          let JWToken = params.token;
          console.log("JWTToken: ", JWToken); 

          var data: any = {};
          data.externaltoken = JWToken;
          this.api.postj("user/security/logingulliver", data, "").subscribe(res => {
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK ) {
              this.authService.next(res[RESPONSE.JP_RESULT]);
              this.fillAccount()
              this.fillOrders()    
            }
          });
        }else{
          //invio a login s sito esterno
          let url = EitUrl.apiLoginGulliver + window.location.href; // + EitEnv.baseUrl + "/cart"; /*state.url*/;
          window.open(url,"_self"/*, "_blank"*/);
        }
      });

    }
    else this.initForms();  
    console.log("dashboard")
    this.tab = this.route.snapshot.data.tab;
    if(this.tab) this.setTitle();
    this.route.queryParams.subscribe(params => {
      if (params && params['tab']) {
        this.tab = parseInt(params['tab']);
        this.setTitle();
      }
    });
  }

  ngOnInit(): void {

    this.appService.appObs.subscribe(x => {  
      this.appData = x;
      if(this.appData) {
        if(this.appData.raccoltapunti) this.fidelity_type = 1 + this.appData.fidelity_type;
        else if(this.appData.fidelity_card) this.fidelity_type = 0;
        this.c_index = this.max = this.appData.conversion_index;
        this.fillFidelity()
        if(this.appData.count_tavoli > 0) this.fillBookings()
      }
    })
    this.fillAccount()
    this.fillOrders()    
  }

  checkPasswords(group: FormGroup) {    
    return group.controls.newpwd.value == null || !group.controls.newpwd.value.length ||
          (group.controls.newpwd.value.length && group.controls.newpwd.value === group.controls.confirmpwd.value) ? null : { notSame: true } ;     
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  changeTab(index: number){
    this.tab = index;
    this.setTitle()
  }

  setTitle(){
    switch(this.tab){
      case ProfileTabs.Account: this.title = "Account"; break;
      case ProfileTabs.Info: this.title = "Informazioni"; break;
      case ProfileTabs.Password: this.title = "Cambia Password"; break;
      case ProfileTabs.Logout: this.title = "Esci"; break;
    }    
    console.log(this.title)
  }

  nextclick(){
    switch(this.tab){
      case ProfileTabs.Info: this.queryPageO++; this.fillOrders(); break;
      case ProfileTabs.Prenotazioni: this.queryPageB++; this.fillBookings(); break;
    }    
  }

  fillFidelity(){
    this.api.postj_T("user/settings/infofidelity", "").subscribe(res => {
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        this.fidelity = res[RESPONSE.JP_RESULT];
        this.n = this.fidelity.eatpoints <= this.max ? this.max - this.fidelity.eatpoints : 0;
        this.couponAvailable = this.n == 0;
      }
    });
  }

  fillAccount(){
    this.api.postj_T("user/settings/infoaccount", "").subscribe(res => {
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        this.accountForm.patchValue(res[RESPONSE.JP_RESULT])
      }
    });
  }

  fillOrders(){
    this.api.postj_T("user/settings/ordersmulti", {PAGE: this.queryPageO}).subscribe(res => {
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        res[RESPONSE.JP_RESULT].forEach((ord: any) => {
          if(ord.slaves.length == 0) this.collapseOrder.push(false)
          else {
            let coll = []
            coll.push(false)
            for(let i = 0; i < ord.slaves.length; i++){
              coll.push(false);
            }
            this.collapseOrder.push(coll)
          }
        });
        this.orders = this.orders.concat(res[RESPONSE.JP_RESULT])
      }
    });
  }

  fillBookings(){
    this.api.postj_T("user/settings/bookings", {PAGE: this.queryPageB}).subscribe(res => {
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        this.bookings = this.bookings.concat(res[RESPONSE.JP_RESULT])
      }
    });
  }

  saveAcc(){
    if(this.accountForm.valid){
      this.api.postj_T("user/settings/updateaccount", this.accountForm.value).subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
          this.toastService.success("Salvato!")
        }
        else this.toastService.error("Controlla i dati inseriti!")
      });
    }
    else this.toastService.error("Controlla i dati inseriti!")
  }

  convert(){
    let modal = this.modalService.open(ConfirmComponent,  { size: 'md', centered: true, ariaLabelledBy: 'Confirm-Modal', windowClass: 'confirm-modal'})
    modal.componentInstance.msg = "Sicuro di voler convertire i tuoi punti in credito?"
    modal.componentInstance.title = "Conversione punti"
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if(event.status == RESPONSE.JPS_OK){
        this.api.postj_T("credit-transactions/converteatpoints", {ep: this.fidelity.eatpoints}, "").subscribe(res => {
          if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
            this.toastService.success("I tuoi Punti fedeltà sono stati convertiti in credito!")
            this.fillFidelity()
          }
        })
      }
    })
  }

  downloadCoupon(){
    this.api.postj_T("user/settings/generatecoupon", {}).subscribe(res => {
      console.log(res);
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        this.toastService.success("Il tuo coupon è stato generato e inviato sulla tua mail!")
        this.fillFidelity()
      }
    })
  }
/*
  recharge(){
    localStorage.setItem(DB.RECHARGE_RETURNURL, JSON.stringify('/account'));
    this.router.navigateByUrl('/user/recharge');
  }
*/
  cancelbook(booking: any){
    let modal = this.modalService.open(CancelbookingComponent, {size: 'md', centered: true, ariaLabelledBy: 'Cancelbooking-Modal', windowClass: 'cancelbooking-modal'})
    modal.componentInstance.booking = booking
    modal.componentInstance.init()
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if(event.status == RESPONSE.JPS_OK){
        this.queryPageB = 0
        this.bookings = []
        this.fillBookings()
      }
    })
  }

  savePwd(){
    if(this.pwdForm.valid){
      this.api.postj_T("user/settings/chkpwd", this.pwdForm.value, "").subscribe(res => {
        if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
          this.toastService.success("Password modificata con successo!")
        }
        else this.toastService.error("Controlla i dati inseriti!")
      });
    }
    else this.toastService.error("Controlla i dati inseriti!")
  }

  logout(){
    this.authService.logout();
    let url = EitUrl.apiLogoutGulliver + EitEnv.baseUrl ; //"/cart"; /*state.url*/; + window.location.href
    window.open(url,"_self"/*, "_blank"*/);
    //this.router.navigateByUrl("/")
  }

  getPath(partner: any){
    return EitUrl.ASSETS_URL + partner.media?.filename + (partner.media_id && partner.media?.path.length > 0 ? '.' + partner.media?.ext : "")
  }

  inputHasError(input: string, error: string){
    return this.accountForm.get(input).invalid && (this.accountForm.get(input).dirty || this.accountForm.get(input).touched) && this.accountForm.get(input).hasError(error)
  }

  inputHasErrorP(input: string, error: string){
    return this.pwdForm.get(input).invalid && (this.pwdForm.get(input).dirty || this.pwdForm.get(input).touched) && this.pwdForm.get(input).hasError(error)
  }

  initForms(){
    this.accountForm = new FormGroup({
      name: new FormControl("", Validators.required),
      lastname: new FormControl("", Validators.required),
      email: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      address: new FormControl("", Validators.required),
      num: new FormControl("", Validators.required),
      townstr: new FormControl("", Validators.required),
      zip: new FormControl("", Validators.required),
      citofono: new FormControl("", Validators.required),
      interno: new FormControl(""),
      newsletter: new FormControl(false),
      profiling: new FormControl(false),
    })

    this.pwdForm = this.fb.group({
      newpwd: new FormControl("", [Validators.required, Validators.minLength(6)]),
      oldpwd: new FormControl("", [Validators.required, Validators.minLength(6)]),
      confirmpwd: new FormControl("", Validators.required)
    }, {validator: this.checkPasswords })
  }
  
  trackOrder(i: number, j?: number){
    if(j != null && j != undefined && i > -1 && j > -1) {
      if (!this.collapseOrder[i][j]){   
        let order = j == 0 ? this.orders[i] : this.orders[i].slaves[j-1]
        this.api.postj_T("order/statustracking", {orderid: order.id}).subscribe(res => {
          if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
            this.collapseOrder[i][j] = true;
            order.status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
            order.cc = res[RESPONSE.JP_RESULT]['cc']
          }
        })
      }        
      else this.collapseOrder[i][j] = false;
    }
    else {
      if(!this.collapseOrder[i]){     
        this.api.postj_T("order/statustracking", {orderid: this.orders[i].id}).subscribe(res => {
          if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
            this.collapseOrder[i] = true;
            this.orders[i].status_tracking = res[RESPONSE.JP_RESULT]['status_tracking']
            this.orders[i].cc = res[RESPONSE.JP_RESULT]['cc']
          }
        })
      }
      else this.collapseOrder[i] = false;
    }
  }

  preparing(order: any){
    let today = new Date().getTime();
    let ptimedate = new Date(order.bookingdate);
    if(order.prepare_time){
      let a = order.prepare_time.split(":")
      ptimedate.setHours(a[0])
      ptimedate.setMinutes(a[1])
    }
    
    return today > ptimedate.getTime();

  }

  ready(order: any){
    let today = new Date().getTime();
    let ptimedate = new Date(order.bookingdate);
    if(order.real_delivery_time){
      let a = order.real_delivery_time.split(":")
      ptimedate.setHours(a[0])
      ptimedate.setMinutes(a[1])
    }
    
    return today > ptimedate.getTime();
  }

  isMulti(order: any){
    let count = 0;
    if(order.status > StatusOrder.CREATED && order.items.length) count++;
    order.slaves.forEach((slave: any) => {
      if(slave.status > StatusOrder.CREATED && slave.items.length)count++;
    });

    return count > 1;
  }
}
